import buildEditorContent from './buildEditorContent';
import createReplyForwardHeaderString from './createReplyForwardHeaderString';
import getTextBodyFromOriginalBody from './getTextBodyFromOriginalBody';
import Message from 'owa-service/lib/contract/Message';
import { trace } from 'owa-trace';

/** Create the body content for an S/MIME mail for reply/reply all/forward operations  */
const createMailResponseBodyContent = (
    message: Message,
    isHtml: boolean,
    subject: string
): string => {
    const originalBody = message.NormalizedBody || message.Body || message.UniqueBody;
    if (!originalBody) {
        trace.error('SmimeTraceError: The body of original message is not available.');
        return '';
    }
    const originalBodyContent = isHtml
        ? originalBody.Value
        : getTextBodyFromOriginalBody(originalBody);
    const headerAsString = createReplyForwardHeaderString(isHtml, message, subject);
    return buildEditorContent(isHtml, originalBodyContent, headerAsString);
};

export default createMailResponseBodyContent;
